module.exports = __webpack_public_path__ + "img/ilustracao-adocao.ef1cdca1.svg";